export enum sortOptionsType {
  New = 'new',
  Old = 'old',
  NameDesk = 'nameDesk',
  NameAsk = 'nameAsk',
  Position = 'position',
}

export const transformSortOptions = (
  value: sortOptionsType | string
): string => {
  const genries: { [key: string]: string } = {
    [sortOptionsType.Position]: 'Выбор редакции',
    [sortOptionsType.New]: 'Сначала новые',
    [sortOptionsType.Old]: 'Сначала старые',
    [sortOptionsType.NameDesk]: 'По названию А—Я',
    [sortOptionsType.NameAsk]: 'По названию Я—А',
  }

  return genries[value] || ''
}
